import AutoAcceptInteract from './AutoAcceptInteract';

export default AutoAcceptInteract;
